/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { SimulateTypes, SimulateAllState } from './types';

const INITIAL_STATE: SimulateAllState = {
  simulate_all: {
    original: {
      invoice: {},
      card: {},
    },
    package_name: '',
    plan_id: '',
    renewal: false,
    card_payment: false,
    plano: 5,
    plan_name: 'Anual',
    services: [],
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<SimulateAllState> = (
  state = INITIAL_STATE,
  { type, result, payment, plan, name, pacote },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case SimulateTypes.GET_SIMULATE_ALL_REQUEST:
        draft.simulate_all.original = INITIAL_STATE.simulate_all.original;
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case SimulateTypes.GET_SIMULATE_ALL_SUCCESS:
        const { package_name, plan_id, renewal } = result.data;
        draft.simulate_all.original = result.data.packages;
        draft.simulate_all.package_name = package_name;
        draft.simulate_all.plan_id = plan_id;
        draft.simulate_all.renewal = renewal;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case SimulateTypes.GET_SIMULATE_ALL_FAILURE:
        draft.simulate_all.original = INITIAL_STATE.simulate_all.original;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case SimulateTypes.GET_ADDITIONAL_SERVICES_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case SimulateTypes.GET_ADDITIONAL_SERVICES_SUCCESS:
        draft.simulate_all.services = result?.data?.servicos;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case SimulateTypes.GET_ADDITIONAL_SERVICES_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case SimulateTypes.STATE_CARD_PAYMENT:
        draft.simulate_all.card_payment = payment;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case SimulateTypes.PLAN_ID_NAME:
        draft.simulate_all.plano = plan;
        draft.simulate_all.plan_name = name;
        draft.simulate_all.package_name = pacote;

        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
